module.exports = __webpack_public_path__ + "img/foodworks-compact.58880531.png";